import { cn } from "@/lib/utils";

export function Brand({ className, showText = true, tone = "default" }) {
  const markColor = tone === "inverse" ? "hsl(var(--primary))" : "hsl(var(--primary))";
  const textColor = tone === "inverse" ? "text-white" : "text-foreground";
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" aria-hidden>
        <rect width="40" height="40" rx="12" fill={markColor} />
        <path
          d="M20 9c-5.5 0-9.5 4-9.5 9.2 0 6.3 7.9 12.3 9.1 13.2.24.17.56.17.8 0 1.2-.9 9.1-6.9 9.1-13.2C29.5 13 25.5 9 20 9Zm0 12.6a3.4 3.4 0 1 1 0-6.8 3.4 3.4 0 0 1 0 6.8Z"
          fill="white"
        />
      </svg>
      {showText && (
        <span className={cn("font-display text-xl tracking-tight", textColor)}>Oppad</span>
      )}
    </div>
  );
}
